import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import Helpers from '../../../../utils/helper';
import { paths } from '../../../../routing/path';

export interface GroupMenuItemProps {
    group: any;
    hasApprovedPractice: boolean;
    isReferral?: boolean;
}

export const GroupMenuItem = (props: GroupMenuItemProps) => {
    const { group, hasApprovedPractice, isReferral } = props;
    const enabled = hasApprovedPractice || isReferral;
    const className =
        group.groupId || group.isCustom
            ? enabled
                ? 'vertical-nav-menu'
                : ' vertical-nav-menu disabled'
            : enabled
              ? 'vertical-nav-menu custom'
              : 'vertical-nav-menu custom disabled';
    const to = group.to ? group.to : paths.venues.grow.practiceManagementPmg(group.groupId);

    return (
        <LeftMenuItem
            icon="pe-7s-users"
            label={Helpers.formatGroupName(group.groupName)}
            to={to}
            flagCode={group.notificationFlagPrefix}
            className={className}
            marginLeft={-15}
            trackingAction={group.groupName}
            forceReload
        />
    );
};
